import * as yup from 'yup';

const validationFields = {
  firstName: yup.string(),
  lastName: yup.string(),
  email: yup
    .string()
    .email('validations.buyerRegistration.email.invalid')
    .required('validations.buyerRegistration.email.required')
    .max(50, 'validations.buyerRegistration.email.maxLength'),
  password: yup
    .string()
    .required('validations.buyerRegistration.password.required')
    .min(8, 'validations.buyerRegistration.password.minLength'),
  phoneNumber: yup
    .string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      'validations.buyerProfile.phoneNumber.invalid',
    ),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const validationEmailSchema = yup.object().shape({ email: validationFields.email });

export const validationPasswordSchema = yup
  .object()
  .shape({ password: validationFields.password, passwordConfirmation: validationFields.passwordConfirmation });

function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: makeid(8),
  phoneNumber: '',
};



// WEBPACK FOOTER //
// ./src/forms/buyerRegistrationForm.js